import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    usuarios: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    presupuestoInternoId: 0,
    usuariosList: [],
    // usuariosIncluidos: [],
    // usuariosIncluir: []
};

const mutations = {
    updateField,

    'INICIALIZAR_USUARIOS' (state) {
        state.usuarios = [];
    },
    'SET_USUARIOS' (state, usuarios) {
        state.usuarios = usuarios;
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LISTAS' (state) {
        state.presupuestoInternoId = 0;
        state.usuariosList = [];
        // state.usuariosIncluidos = [];
        // state.usuariosIncluir = [];
    },
    'SET_LISTAS' (state, params) {
        state.presupuestoInternoId = params.presupuestoInternoId;
        state.usuariosList = params.usuarios;

        state.usuariosList.sort(function(a, b){
            let x = a.usuarioRol.toLowerCase().trim() + ' ' + a.usuario.toLowerCase().trim();
            let y = b.usuarioRol.toLowerCase().trim() + ' ' + b.usuario.toLowerCase().trim();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });
        

        // state.usuariosIncluidos = params.usuariosIncluidos;
        // state.usuariosIncluidos.sort(function(a, b){
        //     let x = a.usuarioRol.toLowerCase().trim() + ' ' + a.nombreCompleto.toLowerCase().trim();
        //     let y = b.usuarioRol.toLowerCase().trim() + ' ' + b.nombreCompleto.toLowerCase().trim();
        //     if (x < y) { 
        //         return -1; 
        //     }
        //     if (x > y) {
        //         return 1;
        //     }
        //     return 0;
        // });

        // state.usuariosIncluir = params.usuariosIncluir;
        // state.usuariosIncluir.sort(function(a, b){
        //     let x = a.usuarioRol.toLowerCase().trim() + ' ' + a.nombreCompleto.toLowerCase().trim();
        //     let y = b.usuarioRol.toLowerCase().trim() + ' ' + b.nombreCompleto.toLowerCase().trim();
        //     if (x < y) { 
        //         return -1; 
        //     }
        //     if (x > y) {
        //         return 1;
        //     }
        //     return 0;
        // });
    },
    // 'INCLUIR_USUARIO' (state, usuarioId) {
    //     let usuario = state.usuariosIncluir.find(usuario => usuario.id == usuarioId);
    //     if (usuario) {
    //         let index = state.usuariosIncluir.findIndex(usuario => usuario.id == usuarioId);
    //         state.usuariosIncluir.splice(index, 1);

    //         state.usuariosIncluidos.push(usuario);

    //         state.usuariosIncluidos.sort(function(a, b){
    //             let x = a.usuarioRol.toLowerCase().trim() + ' ' + a.nombreCompleto.toLowerCase().trim();
    //             let y = b.usuarioRol.toLowerCase().trim() + ' ' + b.nombreCompleto.toLowerCase().trim();
    //             if (x < y) { 
    //                 return -1; 
    //             }
    //             if (x > y) {
    //                 return 1;
    //             }
    //             return 0;
    //         });
    //     }
    // },
    // 'EXCLUIR_USUARIO' (state, usuarioId) {
    //     let usuario = state.usuariosIncluidos.find(usuario => usuario.id == usuarioId);
    //     if (usuario) {
    //         let index = state.usuariosIncluidos.findIndex(usuario => usuario.id == usuarioId);
    //         state.usuariosIncluidos.splice(index, 1);

    //         state.usuariosIncluir.push(usuario);    

    //         state.usuariosIncluir.sort(function(a, b){
    //             let x = a.usuarioRol.toLowerCase().trim() + ' ' + a.nombreCompleto.toLowerCase().trim();
    //             let y = b.usuarioRol.toLowerCase().trim() + ' ' + b.nombreCompleto.toLowerCase().trim();
    //             if (x < y) { 
    //                 return -1; 
    //             }
    //             if (x > y) {
    //                 return 1;
    //             }
    //             return 0;
    //         });
    //     }
    // },
};

const getters = {
    getField,
    usuarios (state) {
        return state.usuarios;
    },
};

const actions = {
    getUsuariosPresupuesto ( { commit }, presupuestoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_USUARIOS');

            apiAxios.get('presupuestosinternosusuarios/' + presupuestoId + '/usuarios')
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAGINATION', params);
                    }
                    commit('SET_USUARIOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));                
        })            
    },
    setUsuarioPresupuesto ( { }, params ) {
        return new Promise((resolve, reject) => {

            let presupuestoInternoUsuario= {
                presupuestoInternoId: parseInt(params.presupuestoInternoId),
                usuarioId: parseInt(params.usuarioId),
                usuarioRolId: parseInt(params.usuarioRolId),
            };

            let url = 'presupuestosinternosusuarios';

            apiAxios.post(url, presupuestoInternoUsuario)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));                
        })
    },
    deleteUsuarioPresupuesto ( {}, params ) {
        return new Promise((resolve, reject) => {

            let presupuestoInternoUsuario= {
                presupuestoInternoId: parseInt(params.presupuestoInternoId),
                usuarioId: parseInt(params.usuarioId),
                usuarioRolId: parseInt(params.usuarioRolId),
            };

            let url = 'presupuestosinternosusuarios/delete';

            apiAxios.post(url, presupuestoInternoUsuario)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    
    getUsuariosAsignar ( { commit }, presupuestoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LISTAS');

            apiAxios.get('presupuestosinternosusuarios/' + presupuestoId)
                .then(res => {
                    // let params = res.data;
                    // params.presupuestoInternoId = presupuestoId;

                    let params = {
                        presupuestoInternoId: presupuestoId,
                        usuarios: res.data
                    }

                    commit('SET_LISTAS', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    // incluirUsuario ( { commit }, usuarioId ) {
    //     return new Promise((resolve, reject) => {
    //         commit('INCLUIR_USUARIO', usuarioId);
    //         resolve();
    //     }, error => {
    //         reject(error);
    //     })            
    // },
    // excluirUsuario ( { commit }, usuarioId ) {
    //     return new Promise((resolve, reject) => {
    //         commit('EXCLUIR_USUARIO', usuarioId);
    //         resolve();
    //     }, error => {
    //         reject(error);
    //     })            
    // },
    setUsuariosPresupuesto ( { state } ) {
        return new Promise((resolve, reject) => {

            let usuariosPresupuesto = state.usuariosList
                .filter(usuario => (/true/i).test(usuario.asignado) == true)
                .map(usuario => {
                        return {
                            usuarioId: parseInt(usuario.usuarioId),
                            usuarioRolId: parseInt(usuario.usuarioRolId),
                        }
                    });
                
            let presupuestoInternoUsuarios = {
                usuarios: usuariosPresupuesto
            }

            let url = 'presupuestosinternosusuarios/' + state.presupuestoInternoId + '/usuarios';

            apiAxios.post(url, presupuestoInternoUsuarios)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}